var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KlevuConfig } from "../../config.js";
import { KlevuLastClickedProducts } from "../../store/lastClickedProducts.js";
import { personalisation } from "../../modifiers/personalisation/personalisation.js";
import { KlevuTypeOfRecord } from "../../models/KlevuTypeOfRecord.js";
import { get } from "../../connection/fetch.js";
var KMCRecommendationPagetype;
(function (KMCRecommendationPagetype) {
    KMCRecommendationPagetype["Home"] = "HOME";
    KMCRecommendationPagetype["Category"] = "CATEGORY";
    KMCRecommendationPagetype["Product"] = "PRODUCT";
    KMCRecommendationPagetype["Checkout"] = "CHECKOUT";
})(KMCRecommendationPagetype || (KMCRecommendationPagetype = {}));
export var KMCRecommendationLogic;
(function (KMCRecommendationLogic) {
    KMCRecommendationLogic["Trending"] = "TRENDING";
    KMCRecommendationLogic["TrendingPersonalized"] = "TRENDING_PERSONALIZED";
    KMCRecommendationLogic["NewestArrivals"] = "NEWEST_ARRIVALS";
    KMCRecommendationLogic["RecentlyViewed"] = "RECENTLY_VIEWED";
    KMCRecommendationLogic["HandPicked"] = "HAND_PICKED";
    KMCRecommendationLogic["OtherAlsoViewed"] = "OTHER_ALSO_VIEWED";
    KMCRecommendationLogic["Similar"] = "SIMILAR";
    KMCRecommendationLogic["BoughtTogether"] = "BOUGHT_TOGETHER";
})(KMCRecommendationLogic || (KMCRecommendationLogic = {}));
/**
 * Fetches products based on KMC recommendation. Provide id created in KMC
 *
 * @category RecommendationQuery
 * @param recommendationId Id of recommendation in the backend
 * @returns
 */
export function kmcRecommendation(recommendationId, options, ...modifiers) {
    return __awaiter(this, void 0, void 0, function* () {
        let kmcConfig;
        try {
            kmcConfig = yield get(`https://config-cdn.ksearchnet.com/recommendations/${KlevuConfig.getDefault().apiKey}/settings/${recommendationId}`);
        }
        catch (e) {
            console.warn("Failed to fetch given KMC recommendation");
            return {
                klevuFunctionId: "kmcRecommendation",
            };
        }
        if (!kmcConfig) {
            throw new Error("Couldn't fetch KMC config");
        }
        const configOverride = new KlevuConfig({
            apiKey: KlevuConfig.getDefault().apiKey,
            url: `https://${kmcConfig.search.basePath}`,
        });
        const payload = JSON.parse(kmcConfig.search.payload);
        const queries = payload.recordQueries.map((query) => {
            var _a;
            return (Object.assign(Object.assign({}, query), { id: (_a = options === null || options === void 0 ? void 0 : options.id) !== null && _a !== void 0 ? _a : "kmcrecommendation" }));
        });
        if (kmcConfig.metadata.pageType === KMCRecommendationPagetype.Home &&
            kmcConfig.metadata.logic === KMCRecommendationLogic.RecentlyViewed) {
            const last10 = KlevuLastClickedProducts.getLastClickedLatestsFirst(10);
            for (const q of queries) {
                if (!q.settings) {
                    q.settings = {};
                }
                q.settings.customeANDQuery = `id:(${last10.join(" OR ")})`;
                q.settings.topIds = last10.map((id) => ({ key: "id", value: id }));
            }
        }
        if (kmcConfig.metadata.pageType === KMCRecommendationPagetype.Category &&
            [
                KMCRecommendationLogic.Trending,
                KMCRecommendationLogic.TrendingPersonalized,
                KMCRecommendationLogic.NewestArrivals,
            ].includes(kmcConfig.metadata.logic)) {
            if (!options || !options.categoryPath) {
                throw new Error("'categoryPath' is required for Category recommendation");
            }
            for (const q of queries) {
                if (!q.settings) {
                    q.settings = {};
                }
                if (!q.settings.query) {
                    q.settings.query = {};
                }
                q.settings.query.categoryPath = options === null || options === void 0 ? void 0 : options.categoryPath;
            }
        }
        if (kmcConfig.metadata.logic === KMCRecommendationLogic.TrendingPersonalized) {
            modifiers.push(personalisation());
        }
        if (kmcConfig.metadata.pageType === KMCRecommendationPagetype.Product &&
            [
                KMCRecommendationLogic.OtherAlsoViewed,
                KMCRecommendationLogic.Similar,
            ].includes(kmcConfig.metadata.logic)) {
            if (!options || !options.currentProductId || !options.itemGroupId) {
                throw new Error("'currentProductId' and 'itemGroupdId' is required for Product recommendation");
            }
            for (const q of queries) {
                if (!q.settings) {
                    q.settings = {};
                }
                if (!q.settings.context) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    q.settings.context = {};
                }
                q.settings.excludeIds = [
                    {
                        key: "itemGroupId",
                        value: options.itemGroupId,
                    },
                ];
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                q.settings.context.recentObjects = [
                    {
                        typeOfRecord: KlevuTypeOfRecord.Product,
                        records: [
                            {
                                id: options.currentProductId,
                            },
                        ],
                    },
                ];
            }
        }
        if (kmcConfig.metadata.pageType === KMCRecommendationPagetype.Checkout &&
            kmcConfig.metadata.logic === KMCRecommendationLogic.BoughtTogether) {
            if (!options || !options.cartProductIds) {
                throw new Error("'cartProductIds' is required for Checkout recommendation");
            }
            for (const q of queries) {
                if (!q.settings) {
                    q.settings = {};
                }
                if (!q.settings.context) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    q.settings.context = {};
                }
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                q.settings.context.recentObjects = [
                    {
                        typeOfRecord: KlevuTypeOfRecord.Product,
                        records: options.cartProductIds.map((id) => ({ id })),
                    },
                ];
            }
        }
        return {
            klevuFunctionId: "kmcRecommendation",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            queries,
            params: {
                kmcConfig,
            },
            modifiers,
            configOverride,
        };
    });
}
